<template>
  <div>
    <el-breadcrumb separator="/" style="padding-bottom: 10px;">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="table">
      <div class="top">
        <div>
          <el-button type="primary" @click="add" size="mini" icon="el-icon-plus" v-if="roleCreateStatus=='true'">新增</el-button>
        </div>
      </div>
      <div class="content">
        <el-table :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" :data="tableData"
                  border
                  style="width: 100%;" size="mini">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="roleDescribe" label="角色名称">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
                    <el-button type="text" @click="dialog(scope.row)" size="small" v-if="roleUpdateStatus=='true'">编辑</el-button>
                    <el-button type="text" @click="permissionSetting(scope.row.roleId)" v-if="roleSettingStatus=='true'" size="small">权限设置</el-button>
                    <el-button style="color: #FF0000;" @click="remove(scope.row.roleId)" type="text" size="small" v-if="roleDeleteStatus=='true'">删除
                    </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom">
        <el-pagination @size-change="handleSizeChange" @current-change="changePage"
                       :current-page="queryData.pageNo"
                       :page-sizes="[15, 25, 40, 50]" :page-size="queryData.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total" style="float: right;">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="新增/编辑"
        :visible.sync="dialogVisible1"
        width="50%">
      <span>
        <el-form ref="formValidate" :rules="ruleValidate" :model="role" size="mini" label-width="150px"
                 class="demo-ruleForm">
          <el-form-item label="角色名称" prop="roleDescribe" style="width: 85%">
            <el-input v-model="role.roleDescribe" placeholder="请输入角色名称"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
         <el-button size="small" @click="dialogVisible1 = false" style="float:left">取 消</el-button>
         <el-form ref="queryData" :model="role" label-width="100px" size="mini">
            <el-button size="small" type="primary" @click="create('formValidate')" v-if="role.mode==0">保存</el-button>
            <el-button size="small" type="primary" @click="update('formValidate')" v-if="role.mode==1">修改</el-button>
         </el-form>
      </span>
    </el-dialog>
    <el-dialog
        title="权限设置"
        :visible.sync="dialogVisible"
        width="50%">
      <Tree :data="data2" show-checkbox ref="permissionTrees"></Tree>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="checkResourceZTree()">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  getPermissionTree,
  saveEnterprisePermissions,
  createRole,
  updateRole,
  deleteRole,
} from "../../request/api.js";

export default {
  name: "Role",
  props: {},
  data() {
    return {
      total: 0,

      roleCreateStatus:window.sessionStorage.getItem('roleCreateStatus'),
      roleListStatus:window.sessionStorage.getItem('roleListStatus'),
      roleUpdateStatus:window.sessionStorage.getItem('roleUpdateStatus'),
      roleDeleteStatus:window.sessionStorage.getItem('roleDeleteStatus'),
      roleSettingStatus:window.sessionStorage.getItem('roleSettingStatus'),

      queryForm: {
        show: false
      },
      queryData: {
        pageNo: 1,
        size: 15,
      },
      role: {
        roleId: '',
        roleDescribe: '',
        mode: 0
      },
      tableData: [],
      dialogVisible: false,
      dialogVisible1: false,
      // 当前分配的角色id
      roleId: '',
      data2: [
        {
          title: 'parent 1',
          // expand: true,
          children: [
            {
              title: 'parent 1-1',
              // expand: false,
              checked: true,
            },
            {
              title: 'parent 1-2',
              // expand: true,
              checked: false,
            }
          ]
        }
      ],
      ruleValidate: {
        roleDescribe: [{
          required: true,
          message: '请输入角色名称',
          trigger: 'blur'
        }],
      }
    }
  },
  methods: {
    permissionSetting(roleId) {
      this.roleId = roleId;
      this.dialogVisible = true;
      getPermissionTree(roleId).then((data) => {
        if (data.code == 20000) {
          this.data2 = data.data
        }
      })
    },
    checkResourceZTree() {
      this.dialogVisible = false;
      let d = this.$refs.permissionTrees.getCheckedNodes();
      for (var i = 0; i < d.length; i++) {
        d[i].roleId = this.roleId
      }
      console.log(d)
      saveEnterprisePermissions(d).then((data) => {
        console.log(data);
      })
    },
    add() {
      this.role.roleId = '';
      this.role.roleDescribe = '';
      this.role.mode = 0;
      this.dialogVisible1 = true;
    },
    dialog(row) {
      this.role.roleId = row.roleId;
      this.role.roleDescribe = row.roleDescribe;
      this.role.mode = 1;
      this.dialogVisible1 = true;
    },
    create(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          createRole(this.role).then((data) => {
            this.dialogVisible1 = false;
              this.$Message.info(data.msg);
            if (data.code == 20000) {
              this.roleList();
            }
          })
        } else {
          this.$Message.error('请输入角色名称!');
        }
      })
    },
    update(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          updateRole(this.role).then((data) => {
            this.dialogVisible1 = false;
              this.$Message.info(data.msg);
            if (data.code == 20000) {
              this.roleList();
            }
          })
        } else {
          this.$Message.error('请输入角色名称!');
        }
      })
    },
    remove(roleId) {
      deleteRole(roleId).then((data) => {
          this.$Message.info(data.msg);
        if (data.code == 20000) {
          this.roleList();
        }
      })
    },
    roleList() {
      roleList().then((data) => {
        if (data.code == 20000) {
          this.tableData = data.data.list;
          this.total = data.data.total;
        }
      })
    },
    handleSizeChange(a) {
      this.queryData.size = a;
      this.roleList()
    },
    changePage(page) {
      this.queryData.pageNo = page;
      this.roleList()
    },
  },
  created() {
    this.roleList();
  }
}
</script>

<style scoped>
.table {
  background: #FFF;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: auto;
}

.top {
  margin-bottom: 10px;
}

.top-query {

}

.show-form {
  font-size: 10px;
  margin-left: 8px;
}

.el-icon-arrow-down {
  display: inline-block;
}

.bottom {
  margin-top: 10px;
  padding-bottom: 25px;
}
</style>
